export const contractContent = [
  {
    text: "Modalidade Desconto Garantido - Energia Fácil",
    link: "https://image.marketing.aurenenergia.com.br/lib/fe3915707564047f7d1778/m/1/c10c2afe-3bb4-4e30-a33e-8bbc00312958.pdf",
    apiInfo: "modalidade_desconto_garantido_energia_facil",
    active: false,
  },
  {
    text: "Modalidade Preço Fixo - Energia Fácil",
    link: "https://image.marketing.aurenenergia.com.br/lib/fe3915707564047f7d1778/m/1/6623a6a6-e450-4821-9701-b0d65150e59c.pdf",
    apiInfo: "modalidade_preco_fixo_energia_facil",
    active: false,
  },
  {
    text: "Modalidade Desconto Garantido",
    link: "https://image.marketing.aurenenergia.com.br/lib/fe3915707564047f7d1778/m/1/ce58412f-6c9d-40e7-8094-710be9e84a4d.pdf",
    apiInfo: "modalidade_desconto_garantido",
    active: false,
  },
  {
    text: "Modalidade Preço Fixo",
    link: "https://image.marketing.aurenenergia.com.br/lib/fe3915707564047f7d1778/m/1/c52954e4-1fdf-4082-a587-04b14b72956a.pdf",
    apiInfo: "modalidade_preco_fixo",
    active: false,
  },
  {
    text: "Modalidade Preço Fixo 2025",
    link: "https://image.marketing.aurenenergia.com.br/lib/fe3915707564047f7d1778/m/1/11bb4c7b-6511-41d8-8a97-acf9b3c32352.pdf",
    apiInfo: "modalidade_preco_fixo",
    active: false,
  },
  {
    text: "Modalidade Desconto Garantido",
    link: "https://image.marketing.aurenenergia.com.br/lib/fe3915707564047f7d1778/m/1/39475aab-7bfe-43ff-a474-8692f9ae7cb9.pdf",
    apiInfo: "modalidade_desconto_garantido",
    active: false,
  },
  {
    text: "Modalidade Preço Fixo 2026",
    link: "https://workdrive.zohoexternal.com/external/88a53fb9cdc12ef6307c7140d620b0a97abb2c51788400c58195382bb7d18e8c/download",
    apiInfo: "modalidade_preco_fixo_2026",
    active: true,
  },
];
